var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.114,
    height: 24.971,
    viewBox: "0 0 38.114 24.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_36_",
    "data-name": "svgexport-6 (36)",
    transform: "translate(0 -88.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90973",
    "data-name": "Path 90973",
    d: "M35.259,88.276H2.854A2.854,2.854,0,0,0,0,91.13v19.262a2.854,2.854,0,0,0,2.854,2.854h32.4a2.854,2.854,0,0,0,2.854-2.854V91.13A2.854,2.854,0,0,0,35.259,88.276Z",
    transform: "translate(0 -0.001)",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90974",
    "data-name": "Path 90974",
    d: "M38.074,90.658a2.855,2.855,0,0,0-2.815-2.383h-.743L22.343,96.251V88.275H15.771v7.976L3.6,88.275H2.854A2.855,2.855,0,0,0,.04,90.658l10.405,6.817H0v6.571H10.445L.04,110.864a2.855,2.855,0,0,0,2.815,2.383H3.6l12.174-7.976v7.976h6.571V105.27l12.174,7.976h.743a2.855,2.855,0,0,0,2.815-2.383l-10.405-6.817H38.114V97.475H27.669Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52531",
    "data-name": "Group 52531",
    transform: "translate(0 88.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90975",
    "data-name": "Path 90975",
    d: "M21.028,88.276H17.085V98.79H0v3.943H17.085v10.514h3.943V102.733H38.114V98.79H21.028Z",
    transform: "translate(0 -88.276)",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90976",
    "data-name": "Path 90976",
    d: "M10.383,309.154l13.889-9.016H21.858l-12.634,8.2A2.858,2.858,0,0,0,10.383,309.154Z",
    transform: "translate(-8.537 -284.367)",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90977",
    "data-name": "Path 90977",
    d: "M316.374,300.138H313.96l13.453,8.732a2.867,2.867,0,0,0,.915-.973Z",
    transform: "translate(-290.588 -284.367)",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90978",
    "data-name": "Path 90978",
    d: "M4.049,96.857l11.742,7.622H18.2L4.9,95.842A2.866,2.866,0,0,0,4.049,96.857Z",
    transform: "translate(-3.748 -95.279)",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90979",
    "data-name": "Path 90979",
    d: "M302.552,99.652l12.658-8.216a2.858,2.858,0,0,0-1.169-.808l-13.9,9.025Z",
    transform: "translate(-277.795 -90.452)",
    fill: "#ff4b55"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UkFlag.a28a3fbf4ccf1ca9629c05787f0718b5.svg";
export { ForwardRef as ReactComponent };